import { RequestStatus } from '../enums';

const requestStatusCheckers = {
  isIdle: status => status === RequestStatus.IDLE,
  isLoading: status => status === RequestStatus.LOADING,
  isSucceeded: status => status === RequestStatus.SUCCEEDED,
  isFailed: status => status === RequestStatus.FAILED,
};

export default requestStatusCheckers;
